/*
 * ATTENTION: An "eval-source-map" devtool has been used.
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file with attached SourceMaps in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./zrc/scripts/base.js":
/*!*****************************!*\
  !*** ./zrc/scripts/base.js ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @shopify/theme-sections */ \"./node_modules/@shopify/theme-sections/theme-sections.js\");\n/* harmony import */ var _layout_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./layout/index */ \"./zrc/scripts/layout/index.js\");\n/**\n * 🏷 Info about theme sections\n * @package: @shopify/theme-sections\n * @url: https://yarnpkg.com/en/package/@shopify/theme-sections\n */\n\n\n\ndocument.addEventListener('DOMContentLoaded', () => {\n  (0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__.load)('*');\n});//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiLi96cmMvc2NyaXB0cy9iYXNlLmpzLmpzIiwic291cmNlcyI6WyJ3ZWJwYWNrOi8vZ2V0bW9yZS13b3JrZmxvdy8uL3pyYy9zY3JpcHRzL2Jhc2UuanM/OTEwMSJdLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIPCfj7cgSW5mbyBhYm91dCB0aGVtZSBzZWN0aW9uc1xuICogQHBhY2thZ2U6IEBzaG9waWZ5L3RoZW1lLXNlY3Rpb25zXG4gKiBAdXJsOiBodHRwczovL3lhcm5wa2cuY29tL2VuL3BhY2thZ2UvQHNob3BpZnkvdGhlbWUtc2VjdGlvbnNcbiAqL1xuXG5pbXBvcnQge2xvYWR9IGZyb20gJ0BzaG9waWZ5L3RoZW1lLXNlY3Rpb25zJztcblxuaW1wb3J0ICcuL2xheW91dC9pbmRleCc7XG5cbmRvY3VtZW50LmFkZEV2ZW50TGlzdGVuZXIoJ0RPTUNvbnRlbnRMb2FkZWQnLCAoKSA9PiB7XG4gIGxvYWQoJyonKTtcbn0pO1xuIl0sIm1hcHBpbmdzIjoiOzs7QUFBQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUVBO0FBRUE7QUFDQTtBQUNBIiwic291cmNlUm9vdCI6IiJ9\n//# sourceURL=webpack-internal:///./zrc/scripts/base.js\n");

/***/ }),

/***/ "./zrc/scripts/layout/header.js":
/*!**************************************!*\
  !*** ./zrc/scripts/layout/header.js ***!
  \**************************************/
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

eval("/* provided dependency */ var $ = __webpack_require__(/*! jquery */ \"./node_modules/jquery/dist/jquery.js\");\n/* eslint-disable no-undef */\nclass HeaderSection extends HTMLElement {\n  connectedCallback() {\n    this.setCssProperties();\n    this.container = this;\n    window.addEventListener('resize', debounce(this.setCssProperties, 100), false);\n    document.addEventListener('rebuy.ready', this.setSmartCartImage.bind(this));\n  }\n  setCssProperties() {\n    const announcementBarHeight = $('#shopify-section-announcement-bar').height();\n    document.documentElement.style.setProperty('--announcement-bar-height', `${announcementBarHeight}px`);\n    const headerHeight = $('.header-main-wrapper').height();\n    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);\n    const viewportHeight = window.innerHeight;\n    document.documentElement.style.setProperty('--viewport-height', `${viewportHeight}px`);\n  }\n  setSmartCartImage() {\n    const smartCart = document.querySelectorAll('#smartcart-bottom-image');\n    if (smartCart.length > 0) {\n      const rebuyCheckout = document.querySelectorAll('#rebuy-cart div[data-rebuy-component=checkout-area]');\n      if (rebuyCheckout.length > 0) {\n        rebuyCheckout[0].appendChild(smartCart[0]);\n      }\n    }\n  }\n}\nif (window.customElements.get('header-section') == null) {\n  window.customElements.define('header-section', HeaderSection);\n}\nfunction debounce(fn, wait) {\n  var _this = this;\n  let t;\n  return function () {\n    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {\n      args[_key] = arguments[_key];\n    }\n    clearTimeout(t);\n    t = setTimeout(() => fn.apply(_this, args), wait);\n  };\n}//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,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\n//# sourceURL=webpack-internal:///./zrc/scripts/layout/header.js\n");

/***/ }),

/***/ "./zrc/scripts/layout/index.js":
/*!*************************************!*\
  !*** ./zrc/scripts/layout/index.js ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @shopify/theme-sections */ \"./node_modules/@shopify/theme-sections/theme-sections.js\");\n/* harmony import */ var _header__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./header */ \"./zrc/scripts/layout/header.js\");\n/* harmony import */ var _header__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_header__WEBPACK_IMPORTED_MODULE_1__);\n\n\ndocument.addEventListener('DOMContentLoaded', () => {\n  (0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__.load)('*');\n});//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiLi96cmMvc2NyaXB0cy9sYXlvdXQvaW5kZXguanMuanMiLCJzb3VyY2VzIjpbIndlYnBhY2s6Ly9nZXRtb3JlLXdvcmtmbG93Ly4venJjL3NjcmlwdHMvbGF5b3V0L2luZGV4LmpzPzljNmYiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHtsb2FkfSBmcm9tICdAc2hvcGlmeS90aGVtZS1zZWN0aW9ucyc7XG5cbmltcG9ydCAnLi9oZWFkZXInO1xuXG5kb2N1bWVudC5hZGRFdmVudExpc3RlbmVyKCdET01Db250ZW50TG9hZGVkJywgKCkgPT4ge1xuICBsb2FkKCcqJyk7XG59KTtcbiJdLCJtYXBwaW5ncyI6Ijs7OztBQUFBO0FBRUE7QUFFQTtBQUNBO0FBQ0EiLCJzb3VyY2VSb290IjoiIn0=\n//# sourceURL=webpack-internal:///./zrc/scripts/layout/index.js\n");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/******/ 	// the startup function
/******/ 	// It's empty as some runtime module handles the default behavior
/******/ 	__webpack_require__.x = x => {};
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// Promise = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"base": 0
/******/ 		};
/******/ 		
/******/ 		var deferredModules = [
/******/ 			["./zrc/scripts/base.js","commons"]
/******/ 		];
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		var checkDeferredModules = x => {};
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime, executeModules] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0, resolves = [];
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					resolves.push(installedChunks[chunkId][0]);
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			while(resolves.length) {
/******/ 				resolves.shift()();
/******/ 			}
/******/ 		
/******/ 			// add entry modules from loaded chunk to deferred list
/******/ 			if(executeModules) deferredModules.push.apply(deferredModules, executeModules);
/******/ 		
/******/ 			// run deferred modules when all chunks ready
/******/ 			return checkDeferredModules();
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = globalThis["webpackChunkgetmore_workflow"] = globalThis["webpackChunkgetmore_workflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 		
/******/ 		function checkDeferredModulesImpl() {
/******/ 			var result;
/******/ 			for(var i = 0; i < deferredModules.length; i++) {
/******/ 				var deferredModule = deferredModules[i];
/******/ 				var fulfilled = true;
/******/ 				for(var j = 1; j < deferredModule.length; j++) {
/******/ 					var depId = deferredModule[j];
/******/ 					if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferredModules.splice(i--, 1);
/******/ 					result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 				}
/******/ 			}
/******/ 			if(deferredModules.length === 0) {
/******/ 				__webpack_require__.x();
/******/ 				__webpack_require__.x = x => {};
/******/ 			}
/******/ 			return result;
/******/ 		}
/******/ 		var startup = __webpack_require__.x;
/******/ 		__webpack_require__.x = () => {
/******/ 			// reset startup function so it can be called again when more startup code is added
/******/ 			__webpack_require__.x = startup || (x => {});
/******/ 			return (checkDeferredModules = checkDeferredModulesImpl)();
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// run startup
/******/ 	__webpack_require__.x();
/******/ })()
;